import React from 'react';
import { useI18n } from '../i18n';
import LegalLayout from './LegalLayout';

export default function MentionsLegales() {
  const { t } = useI18n();
  const m = t.legal.mentions;
  return (
    <LegalLayout eyebrow={m.eyebrow} title={m.title}>
      <h2>{m.hEditor}</h2>
      <p>{m.pEditor}</p>
      <h2>{m.hHosting}</h2>
      <p>{m.pHosting}</p>
      <h2>{m.hIp}</h2>
      <p>{m.pIp}</p>
      <h2>{m.hData}</h2>
      <p>{m.pData}</p>
      <h2>{m.hResp}</h2>
      <p>{m.pResp}</p>
    </LegalLayout>
  );
}
